// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"93":"d545f5a9","420":"236dd84b"}[chunkId] + ".chunk.js";
};